module.exports = __webpack_public_path__ + "static/media/ram.ba96fbd1.svg";